import React from 'react';

const connections = [
  { initials: 'AJ', bg: 'bg-username'    }, { initials: 'SM', bg: 'bg-instagram'  },
  { initials: 'RK', bg: 'bg-green'       }, { initials: 'TP', bg: 'bg-safforn'    },
  { initials: 'NL', bg: 'bg-voilet'      }, { initials: 'DW', bg: 'bg-lred'       },
  { initials: 'CG', bg: 'bg-lblue'       }, { initials: 'MH', bg: 'bg-lgreen'     },
  { initials: 'JB', bg: 'bg-bemedian'    }, { initials: 'KR', bg: 'bg-activity'   },
  { initials: 'OT', bg: 'bg-light-green' }, { initials: 'PV', bg: 'bg-light-orange'},
];

const SectionCard = ({ children, extraClass = '' }) => (
  <div className={`bg-white brd-10 shadow-small p-20 m-b-20 ${extraClass}`}>{children}</div>
);

const CardHeader = ({ title, action, onAction }) => (
  <div className="flex justspacebetween aligncenter m-b-15">
    <span className="fw700 font-15 color-black">{title}</span>
    {action && <span className="font-12 highlight pointer fw500" onClick={onAction}>{action}</span>}
  </div>
);

const ConnectionsTab = () => {
  return (
    <SectionCard>
      <CardHeader title="Your Connections" action="Find New" />
      <div className="grid-4col gap-15">
        {connections.map((c, i) => (
          <div key={i} className="text-center p-15 br-grey brd-10">
            <div className={`circle-avatar-md flex aligncenter justifycenter fw700 font-18 text-white mx-auto m-b-10 ${c.bg}`}>{c.initials}</div>
            <div className="font-13 fw500 dark-navy">Member {i + 1}</div>
            <div className="font-11 lgrey">Chicago Chapter</div>
            <button className="bg-blue-white highlight brd-5 fw500 font-12 w-100p p-5 m-t-10 no-border pointer">Connect</button>
          </div>
        ))}
      </div>
    </SectionCard>
  );
};

export default ConnectionsTab;